import React from 'react'
import {YandexIdBtn} from '../containers/third-party/yandex-id/btn'
import {OAuthProvider} from '@/src/config/settings'
import {VKBtn} from '@/src/features/auth/containers/third-party/vk/btn'

export const OAuthComponentMapping: Partial<Record<ValuesOf<typeof OAuthProvider>, React.FC>> = {
  [OAuthProvider.YandexId]: YandexIdBtn,
  [OAuthProvider.VK]: VKBtn,
}
